import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/sub_cost_centers/`, data);
};

const getAll = async () => {
  return await httpClient.get(`/sub_cost_centers/?page[size]=1000`);
};

const get = async (id) => {
  return await httpClient.get(`/sub_cost_centers/${id}`);
};

const put = async (id, data) => {
  return await httpClient.put(`/sub_cost_centers/${id}/`, data);
};

const patch = async (id, data) => {
  return await httpClient.patch(`/sub_cost_centers/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`/sub_cost_centers/${id}`);
};

export { post, getAll, get, put, patch, remove };
